<template>
    <v-form ref="form" autocomplete="off" @submit.prevent="save" >
        <v-row>

                   <v-col cols="12" sm="6">
                        <user-combobox v-model="form.creadoPor" :input-errors="inputErrors" />
                   </v-col>


                    <v-col cols="12" sm="6">
                        <v-text-field

                                prepend-icon="link"
                                name="url"
                                v-model="form.url"
                                :label="$t('cobrox.reporteStock.labels.url')"
                                :placeholder="$t('cobrox.reporteStock.labels.url')"
                                :error="hasInputErrors('url')"
                                :error-messages="getInputErrors('url')"
                                color="secondary"

                        ></v-text-field>
                    </v-col>


                    <v-col cols="12" sm="6">
                        <v-text-field

                                prepend-icon="table_chart"
                                name="data"
                                v-model="form.data"
                                :label="$t('cobrox.reporteStock.labels.data')"
                                :placeholder="$t('cobrox.reporteStock.labels.data')"
                                :error="hasInputErrors('data')"
                                :error-messages="getInputErrors('data')"
                                color="secondary"

                        ></v-text-field>
                    </v-col>

        </v-row>
    </v-form>
</template>

<script>

    import {InputErrorsByProps, RequiredRule } from '@dracul/common-frontend'
    import {UserCombobox } from '@dracul/user-frontend'



    export default {
        name: "ReporteStockForm",
        mixins: [InputErrorsByProps, RequiredRule    ],
        components: { UserCombobox},
        props:{
            value: {
                type: Object,
                required: true
            },
        },
        computed: {
           form: {
                get() { return this.value },
                set(val) {this.$emit('input', val)}
            }
        },
         watch: {
            form: {
                handler(newVal) {
                    this.$emit('input', newVal)
                },
                deep: true
            }
        },
        methods: {
            validate(){
              return this.$refs.form.validate()
            }
        },
        data(){
            return {

            }
        }
    }
</script>

<style scoped>

</style>

